import { render, staticRenderFns } from "./TopBarContainer.vue?vue&type=template&id=47053cfe&scoped=true"
import script from "./TopBarContainer.vue?vue&type=script&lang=js"
export * from "./TopBarContainer.vue?vue&type=script&lang=js"
import style0 from "./TopBarContainer.vue?vue&type=style&index=0&id=47053cfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47053cfe",
  null
  
)

export default component.exports